/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { AttributeDefinition } from './attributeDefinition';
import { Schema } from './schema';


export interface BusinessObjectFormatCreateRequest { 
    /**
     * The Namespace to which this Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which this Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under this Business Object Format                
     */
    businessObjectFormatFileType: string;
    /**
     * The partition key for this Business Object Format
     */
    partitionKey: string;
    /**
     * Description of the Business Object Format
     */
    description?: string;
    /**
     * The schema for document-style business object data registered with Herd.                   The schema allows the publisher to perform self-service validation of incoming data when registering business object data. It also allows                   the consumers to perform self-service downstream actions like hydrating objects when consuming business object data. The documentSchema is                   optional. Currently any documentSchema is accepted. Its content is not validated                
     */
    documentSchema?: string;
    /**
     * An optional URL of the documentSchema to an externally hosted XSD or JSON. Herd will not access this URL,                   it will simply store and retrieve the URL                
     */
    documentSchemaUrl?: string;
    /**
     * Custom user-defined metadata associated with this Business Object Format. \"name\" is the attribute name (i.e. the key) and                   \"value\" is the attribute value                
     */
    attributes?: Array<Attribute>;
    /**
     * List of attribute definitions (for storage of custom user-defined metadata with objects) which are required to be specified                   when registering Business Object Data against this format. This list will define which metadata must be specified, but additional metadata can                   still be registered which is not specified in this list. The metadata (attributes) will allow applications to store custom data with                   registered data for use by consumers of the data                
     */
    attributeDefinitions?: Array<AttributeDefinition>;
    /**
     * If true, enables Business Object Data Published Attributes Change Event Notification for all business object data registered                   under this business object format version                
     */
    enableBusinessObjectDataPublishedAttributesChangeEventNotification?: boolean;
    schema?: Schema;
    /**
     * Contains Relational Schema Name if the Format is of type Relational Table
     */
    relationalSchemaName?: string;
    /**
     * Contains Relational Table Name if the Format is of type Relational Table
     */
    relationalTableName?: string;
}
